export const HUBSPOT_PORTAL_ID = "5957403";
export const HUBSPOT_NPS_FORM_ID = "c61fe98f-02f4-44cf-af67-98c9b2aebad6";
export const HUBSPOT_FORM_SUBMIT_ENDPOINT_URL =
  "https://api.hsforms.com/submissions/v3/integration/submit";
export const HUBSPOT_OBJECT_TYPE_ID = "0-1";
